import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import './login.css';
import { IoEye, IoEyeOff } from "react-icons/io5";
import { FaLock } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";
import { MdKeyboardArrowLeft } from "react-icons/md";
import logo1 from "../../Assets/Img/logo.png";
import { useAuth } from '../../Auth/AuthContext'; // Import the auth context

const Login = () => {
    const [show, setShow] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useAuth();

    // Determine where to redirect after login; default to '/dash'
    const from = location.state?.from?.pathname || '/dash';

    const handleShow = () => {
        setShow(!show);
    };

    const handleLogin = async () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!email || !password) {
            setError("Please fill out all fields!");
        } else if (!emailRegex.test(email)) {
            setError("Please enter a valid email address!");
        } else {
            setError("");
            // Use the dummy login function from AuthContext
            const isAuthenticated = await login(email, password);
            if (isAuthenticated) {
                navigate(from, { replace: true });
            } else {
                setError("Invalid credentials. Please try again.");
            }
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleLogin();
        }
    };

    return (
        <div>
            <div className='back1'>
                <Link to='/'><span className='backbtn1'><MdKeyboardArrowLeft /></span></Link>
            </div>

            <div className="header">
                <h1>WELCOME TO POOL ROUTE MONITOR!</h1>
            </div>

            <div className="login-container1">
                <div className="logo1">
                    <img src={logo1} alt="Pool Route Monitor Logo" />
                </div>

                <form onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
                    <div className="input-group1">
                        <span className="icon1"><IoMdMail /></span>
                        <input
                            className='input'
                            type="text"
                            placeholder="Email ID"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                    </div>

                    <div className="input-group1">
                        <span className="icon1"><FaLock /></span>
                        <input
                            className='input'
                            type={show ? "text" : "password"}
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                        <span className="toggle-password1" onClick={handleShow}>
                            {show ? <IoEyeOff /> : <IoEye />}
                        </span>
                    </div>

                    {error && <p className="error-message1">{error}</p>}

                    <button type="button" className="btn-login1" onClick={handleLogin}>Login</button>
                    <div className="forgot-password1">
                        <Link to='/passreset'>Forgot Password ?</Link>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Login;
